<mat-dialog-actions class="justify-content-between">
    <h3 *ngIf="isEdit">{{ 'LABEL.UPDATE_LABEL' | translate }} {{ 'ENTITY.ROOM' | translate }}</h3>
    <h3 *ngIf="!isEdit">{{ 'LABEL.ADD_LABEL' | translate }} {{ 'ENTITY.ROOM' | translate }}</h3>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="roomForm">
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'ENTITY.ROOM_TYPE' | translate }}</mat-label>
                    <mat-select formControlName="roomTypeId">
                        @for (roomType of roomTypeddl; track roomType) {
                        <mat-option [value]="roomType.id">{{roomType.name}}</mat-option>
                        }
                    </mat-select>
                    <mat-error *ngIf="roomForm.get('roomTypeId')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.FLOOR' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.FLOOR' | translate }}" formControlName="floor">
                    <mat-error *ngIf="roomForm.get('floor')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM5' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomForm.get('floor')?.hasError('invalidNumber')">
                        {{ 'REQUIRED.ONLY_NUMBER' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.ROOM_NUMBER' | translate }}</mat-label>
                    <input matInput placeholder="{{ 'LABEL.ROOM_NUMBER' | translate }}" formControlName="roomNumber"
                        appCapitalizeFirstLetter>
                    <mat-error *ngIf="roomForm.get('roomNumber')?.hasError('required')">
                        {{ 'REQUIRED.NAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="roomForm.get('roomNumber')?.hasError('maxlength')">
                        {{ 'REQUIRED.MAXIMUM5' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.STATUS' | translate }}</mat-label>
                    <mat-select formControlName="status">
                        <mat-option *ngFor="let status of roomstatusList" [value]="status">
                            {{ roomStatusData[status] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-label><strong>{{'LABEL.IS_ACTIVE' | translate }}:</strong></mat-label>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <mat-checkbox class="example-margin" color="primary" formControlName="isActive"></mat-checkbox>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onUpdateRoom()" *ngIf="isEdit"
                [disabled]="roomForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>

            <button mat-flat-button color="primary" class=" m-l-4" (click)="onAddRoom()" *ngIf="!isEdit"
                [disabled]="roomForm.invalid">
                {{ 'BUTTON.BTN_SAVE' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>